// extracted by mini-css-extract-plugin
export var container = "_bc-1";
export var cornerButtonContainer = "_bc-5";
export var disabled = "_bc-2";
export var fileContainer = "_bc-4";
export var hiddenInput = "_bc-3";
export var widthContainer = "_bc-0";